import React from 'react';

import type { BaseTheme, ThemeType } from '../types';

import {
  DefaultFooterLogo,
  DefaultHeaderLogo,
  DefaultLeftBackgroundImage,
  DefaultRightBackgroundImage,
} from './icons/default';
import {
  PayrollFooterLogo,
  PayrollHeaderLogo,
  PayrollLeftBackgroundImage,
  PayrollRightBackgroundImage,
} from './icons/payroll';

const baseTheme: BaseTheme = {
  backgroundColor: '#F8F8F9',
  textColor: '#585C62',
};

export const defaultReckonTheme: ThemeType = {
  title: 'Reckon',
  publicSubFolder: 'reckon',
  tenant: 'RECKON',
  product: 'default',
  baseTheme: baseTheme,
  productTheme: {
    headerLogo: <DefaultHeaderLogo />,
    footerLogo: <DefaultFooterLogo />,
    leftBackgroundImage: <DefaultLeftBackgroundImage />,
    rightBackgroundImage: <DefaultRightBackgroundImage />,
    footerDescription: 'Made for every small business',
  },
};

export const ReckonThemes: Array<ThemeType> = [
  {
    title: 'Payroll Web',
    publicSubFolder: 'reckon',
    tenant: 'RECKON',
    product: 'payroll',
    baseTheme: baseTheme,
    productTheme: {
      headerLogo: <PayrollHeaderLogo />,
      footerLogo: <PayrollFooterLogo />,
      leftBackgroundImage: <PayrollLeftBackgroundImage />,
      rightBackgroundImage: <PayrollRightBackgroundImage />,
    },
  },
  { ...defaultReckonTheme },
];
